const DEFAULT_REDIRECT_PATH = '/dashboard';
const INTENDED_ROUTE_KEY = 'betmate.intendedRoute';

export const isSafeInternalPath = (path) => (
  typeof path === 'string'
  && path.startsWith('/')
  && !path.startsWith('//')
  && !path.includes('://')
  && !path.includes('\\')
);

export const saveIntendedRoute = (path) => {
  if (!isSafeInternalPath(path)) {
    return;
  }

  try {
    sessionStorage.setItem(INTENDED_ROUTE_KEY, path);
  } catch {
    // Storage can be unavailable in restricted browser modes; fallback redirect remains safe.
  }
};

export const consumeIntendedRoute = () => {
  try {
    const path = sessionStorage.getItem(INTENDED_ROUTE_KEY);
    sessionStorage.removeItem(INTENDED_ROUTE_KEY);
    return isSafeInternalPath(path) ? path : DEFAULT_REDIRECT_PATH;
  } catch {
    return DEFAULT_REDIRECT_PATH;
  }
};

export const defaultRedirectPath = DEFAULT_REDIRECT_PATH;
